module.exports = __webpack_public_path__ + "img/Kinder.af9effba.png";